export function isDeletedRow(row: Record<string, unknown>): boolean {
  return row.is_deleted === true || row.is_deleted === 1
}

export function deleteConfirmMessage(rows: Array<Record<string, unknown>>): string {
  const n = rows.length
  const base = `Delete ${n} record(s)?`
  if (rows.some(isDeletedRow)) {
    return `${base} Marked records will be permanently removed.`
  }
  return base
}

export function hierarchyDeleteConfirmMessage(selectedCount: number): string {
  return `Delete ${selectedCount} record(s) and their non-predefined descendants?`
}
